import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const footerLinks = {
  services: {
    title: '服务产品',
    items: categories.slice(0, 4).map((c) => ({ label: c.name, href: `/category/${c.slug}` })),
  },
  about: {
    title: '关于我们',
    items: [
      { label: '品牌介绍', href: '/about' },
      { label: '发展历程', href: '/about#milestones' },
      { label: '联系我们', href: '/about#contact' },
    ],
  },
  support: {
    title: '帮助支持',
    items: [
      { label: '帮助中心', href: '/article/chuxuezhe-jiujiuzaixian-ruMen' },
      { label: '常见问题', href: '/#faq' },
      { label: '用户反馈', href: '/about#contact' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="inline-block cursor-pointer">
                <span className="font-heading text-xl font-bold text-primary-600">久久在线</span>
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                随时随地，畅享在线服务
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line text-sm"></i>
                </a>
              </div>
            </div>

            {Object.values(footerLinks).map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-foreground-900 mb-4">{section.title}</h4>
                <ul className="space-y-2.5">
                  {section.items.map((item) => (
                    <li key={item.label}>
                      <Link
                        to={item.href}
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-secondary-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 久久在线 版权所有 | 京ICP备2026XXXXXXXX号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">网站地图</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}